import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { isToday, isWeekEnd, isOdd } from "@pages/sharedTimeSheetUtils";
import { getDaysTexts } from "./utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Week({ week }: Props) {
  const { t } = useTranslation();
  const daysNames = getDaysTexts(t);

  return (
    <div className={styles.week}>
      {week.map((day, index) => (
        <div
          key={index}
          className={classNames(styles.day, {
            [styles.today]: isToday(day),
            [styles.weekEnd]: isWeekEnd(day),
          })}
        >
          <p className={styles.name}>{daysNames[index].slice(0, 3)}</p>
          <p className={styles.nbr}>{day.day < 10 ? `0${day.day}` : day.day}</p>
        </div>
      ))}
    </div>
  );
}

export { Week };
